import i18n, { Module } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import TRANSLATION_CZ from 'translations/czech';
import TRANSLATION_DE from 'translations/german';
import TRANSLATION_EN from 'translations/english';
import TRANSLATION_EN_GB from 'translations/britishEnglish';
import TRANSLATION_ES from 'translations/spanish';
import TRANSLATION_FR from 'translations/french';
import TRANSLATION_IT from 'translations/italian';
import TRANSLATION_JP from 'translations/japanese';
import TRANSLATION_KO from 'translations/korean';
import TRANSLATION_PT from 'translations/portuguese';
import TRANSLATION_RU from 'translations/russian';
import TRANSLATION_ZH_HANS from 'translations/simplifiedChinese';
import TRANSLATION_ZH_HANT from 'translations/traditionalChinese';

export const LanguageCodes = {
  CZ: 'cz',
  DE: 'de',
  EN: 'en',
  'en-GB': 'en-GB',
  ES: 'es',
  FR: 'fr',
  IT: 'it',
  JA: 'ja',
  JP: 'jp',
  KO: 'ko',
  PT: 'pt',
  RU: 'ru',
  ZH: 'zh',
  'zh-CN': 'zh-CN',
  'zh-HK': 'zh-HK',
  'zh-Hans': 'zh-Hans',
  'zh-Hant': 'zh-Hant',
  'zh-MO': 'zh-MO',
  'zh-SG': 'zh-SG',
  'zh-TW': 'zh-TW',
} as const;

export type Language = (typeof LanguageCodes)[keyof typeof LanguageCodes];

const translations: Record<
  Language,
  { translation: Record<string, string | object> }
> = {
  cz: { translation: TRANSLATION_CZ },
  de: { translation: TRANSLATION_DE },
  en: { translation: TRANSLATION_EN },
  'en-GB': { translation: TRANSLATION_EN_GB },
  es: { translation: TRANSLATION_ES },
  fr: { translation: TRANSLATION_FR },
  it: { translation: TRANSLATION_IT },
  ja: { translation: TRANSLATION_JP },
  jp: { translation: TRANSLATION_JP },
  ko: { translation: TRANSLATION_KO },
  pt: { translation: TRANSLATION_PT },
  ru: { translation: TRANSLATION_RU },
  zh: { translation: TRANSLATION_ZH_HANS },
  'zh-CN': { translation: TRANSLATION_ZH_HANS },
  'zh-HK': { translation: TRANSLATION_ZH_HANT },
  'zh-Hans': { translation: TRANSLATION_ZH_HANS },
  'zh-Hant': { translation: TRANSLATION_ZH_HANT },
  'zh-MO': { translation: TRANSLATION_ZH_HANT },
  'zh-SG': { translation: TRANSLATION_ZH_HANS },
  'zh-TW': { translation: TRANSLATION_ZH_HANT },
};

// Custom detector to handle ?lang= or ?lng=
const customDetector = {
  name: 'customQueryDetector',
  lookup(): string | undefined {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang') || urlParams.get('lng');
    return lang ?? undefined;
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(customDetector);

i18n
  .use(languageDetector as Module)
  .use(initReactI18next)
  .init({
    fallbackLng: LanguageCodes.EN,
    debug: process.env.NODE_ENV === 'development',
    resources: translations,
    detection: {
      order: [
        'customQueryDetector',
        'queryString',
        'path',
        'subdomain',
        'localStorage',
        'navigator',
      ],
    },
  });

export default i18n;
